<app-header title="Home" />

<ion-content class="home-shell">
  <section class="home-content">
    <a class="home-tile" routerLink="/actions">
      <div class="home-tile__icon-wrapper home-tile__icon-wrapper--actions">
        <ion-icon name="list-outline" />
      </div>
      <div class="home-tile__body">
        <span class="home-tile__title">Actions</span>
        <span class="home-tile__description">Plan and review your actions</span>
      </div>
      <ion-icon class="home-tile__chevron" name="chevron-forward" />
    </a>

    @if (materialsEnabled) {
      <a class="home-tile" routerLink="/materials">
        <div class="home-tile__icon-wrapper home-tile__icon-wrapper--materials">
          <ion-icon name="cube-outline" />
        </div>
        <div class="home-tile__body">
          <span class="home-tile__title">Materials</span>
          <span class="home-tile__description">Browse your stock and leave notes</span>
        </div>
        <ion-icon class="home-tile__chevron" name="chevron-forward" />
      </a>
    }

    <a class="home-tile" routerLink="/profile">
      <div class="home-tile__icon-wrapper home-tile__icon-wrapper--profile">
        <ion-icon name="person-outline" />
      </div>
      <div class="home-tile__body">
        <span class="home-tile__title">Profile</span>
        <span class="home-tile__description">Manage your account and settings</span>
      </div>
      <ion-icon class="home-tile__chevron" name="chevron-forward" />
    </a>
  </section>
</ion-content>
